import { useListProducts } from '@/apis/products.api';
import { useProductsStore } from '@/stores/products.store';

export const useProducts = () => {
  const { selectedCategoryId, currentPage, setSelectedCategoryId, setCurrentPage, resetFilters } = useProductsStore();

  const { data, isLoading, error } = useListProducts({
    page: currentPage,
    categoryId: selectedCategoryId || undefined,
  });

  const handleCategoryFilter = (categoryId: string | null) => {
    setSelectedCategoryId(categoryId);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return {
    products: data?.products || [],
    total: data?.total || 0,
    page: data?.page || 1,
    pageSize: data?.pageSize || 20,
    totalPages: data?.totalPages || 0,
    isLoading,
    error,
    selectedCategoryId,
    handleCategoryFilter,
    handlePageChange,
    resetFilters,
  };
};
